import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CallCostRegisterState, callCostsRegisterFeatureKey } from './call-cost-register.reducer';

const callCostRegisterSelector = createFeatureSelector<CallCostRegisterState>(callCostsRegisterFeatureKey);

export const selectFilters = createSelector(callCostRegisterSelector, (state) => {
   return state.filters;
});
